/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SearchRuleFormConfiguration,
    SearchRuleFormConfigurationFromJSON,
    SearchRuleFormConfigurationToJSON,
    SearchRuleFormData,
    SearchRuleFormDataFromJSON,
    SearchRuleFormDataToJSON,
    SearchRuleListItem,
    SearchRuleListItemFromJSON,
    SearchRuleListItemToJSON,
    SearchRuleStateResponse,
    SearchRuleStateResponseFromJSON,
    SearchRuleStateResponseToJSON,
    SearchRuleValidationData,
    SearchRuleValidationDataFromJSON,
    SearchRuleValidationDataToJSON,
    SearchSubRuleDelete,
    SearchSubRuleDeleteFromJSON,
    SearchSubRuleDeleteToJSON,
    SearchSubRuleListItemPaginationWrapper,
    SearchSubRuleListItemPaginationWrapperFromJSON,
    SearchSubRuleListItemPaginationWrapperToJSON,
    SearchSubRuleQuery,
    SearchSubRuleQueryFromJSON,
    SearchSubRuleQueryToJSON,
    SearchSubRuleState,
    SearchSubRuleStateFromJSON,
    SearchSubRuleStateToJSON,
    SearchSubRuleStateResponse,
    SearchSubRuleStateResponseFromJSON,
    SearchSubRuleStateResponseToJSON,
} from '../models';

export interface ApiSearchManagerV2SearchRuleFormCreatePostRequest {
    searchRuleFormData?: SearchRuleFormData;
}

export interface ApiSearchManagerV2SearchRuleFormDeleteDeleteRequest {
    id?: string;
}

export interface ApiSearchManagerV2SearchRuleFormDeleteRuleBulkDeleteRequest {
    searchSubRuleDelete: Array<SearchSubRuleDelete>;
}

export interface ApiSearchManagerV2SearchRuleFormGetByIdGetRequest {
    id?: string;
}

export interface ApiSearchManagerV2SearchRuleFormSearchesPostRequest {
    searchSubRuleQuery?: SearchSubRuleQuery;
}

export interface ApiSearchManagerV2SearchRuleFormUpdatePostRequest {
    searchRuleFormData?: SearchRuleFormData;
}

export interface ApiSearchManagerV2SearchRuleFormUpdateStateBulkPostRequest {
    searchSubRuleState: Array<SearchSubRuleState>;
}

export interface ApiSearchManagerV2SearchRuleFormValidatePostRequest {
    searchRuleFormData?: SearchRuleFormData;
}

/**
 * no description
 */
export class SearchRuleFormApi extends runtime.BaseAPI {

    /**
     */
    async apiSearchManagerV2SearchRuleFormCreatePostRaw(requestParameters: ApiSearchManagerV2SearchRuleFormCreatePostRequest): Promise<runtime.ApiResponse<SearchRuleListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRuleFormDataToJSON(requestParameters.searchRuleFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchRuleListItemFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormCreatePost(requestParameters: ApiSearchManagerV2SearchRuleFormCreatePostRequest): Promise<SearchRuleListItem> {
        const response = await this.apiSearchManagerV2SearchRuleFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormDeleteDeleteRaw(requestParameters: ApiSearchManagerV2SearchRuleFormDeleteDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleForm/Delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormDeleteDelete(requestParameters: ApiSearchManagerV2SearchRuleFormDeleteDeleteRequest): Promise<void> {
        await this.apiSearchManagerV2SearchRuleFormDeleteDeleteRaw(requestParameters);
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormDeleteRuleBulkDeleteRaw(requestParameters: ApiSearchManagerV2SearchRuleFormDeleteRuleBulkDeleteRequest): Promise<runtime.ApiResponse<Array<SearchRuleStateResponse>>> {
        if (requestParameters.searchSubRuleDelete === null || requestParameters.searchSubRuleDelete === undefined) {
            throw new runtime.RequiredError('searchSubRuleDelete','Required parameter requestParameters.searchSubRuleDelete was null or undefined when calling apiSearchManagerV2SearchRuleFormDeleteRuleBulkDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleForm/DeleteRuleBulk`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.searchSubRuleDelete.map(SearchSubRuleDeleteToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SearchRuleStateResponseFromJSON));
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormDeleteRuleBulkDelete(requestParameters: ApiSearchManagerV2SearchRuleFormDeleteRuleBulkDeleteRequest): Promise<Array<SearchRuleStateResponse>> {
        const response = await this.apiSearchManagerV2SearchRuleFormDeleteRuleBulkDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormFormConfigurationGetRaw(): Promise<runtime.ApiResponse<SearchRuleFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleForm/FormConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchRuleFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormFormConfigurationGet(): Promise<SearchRuleFormConfiguration> {
        const response = await this.apiSearchManagerV2SearchRuleFormFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormGetByIdGetRaw(requestParameters: ApiSearchManagerV2SearchRuleFormGetByIdGetRequest): Promise<runtime.ApiResponse<SearchRuleFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleForm/GetById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchRuleFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormGetByIdGet(requestParameters: ApiSearchManagerV2SearchRuleFormGetByIdGetRequest): Promise<SearchRuleFormData> {
        const response = await this.apiSearchManagerV2SearchRuleFormGetByIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormSearchesPostRaw(requestParameters: ApiSearchManagerV2SearchRuleFormSearchesPostRequest): Promise<runtime.ApiResponse<SearchSubRuleListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleForm/Searches`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchSubRuleQueryToJSON(requestParameters.searchSubRuleQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSubRuleListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormSearchesPost(requestParameters: ApiSearchManagerV2SearchRuleFormSearchesPostRequest): Promise<SearchSubRuleListItemPaginationWrapper> {
        const response = await this.apiSearchManagerV2SearchRuleFormSearchesPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormUpdatePostRaw(requestParameters: ApiSearchManagerV2SearchRuleFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRuleFormDataToJSON(requestParameters.searchRuleFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormUpdatePost(requestParameters: ApiSearchManagerV2SearchRuleFormUpdatePostRequest): Promise<void> {
        await this.apiSearchManagerV2SearchRuleFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormUpdateStateBulkPostRaw(requestParameters: ApiSearchManagerV2SearchRuleFormUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<SearchSubRuleStateResponse>>> {
        if (requestParameters.searchSubRuleState === null || requestParameters.searchSubRuleState === undefined) {
            throw new runtime.RequiredError('searchSubRuleState','Required parameter requestParameters.searchSubRuleState was null or undefined when calling apiSearchManagerV2SearchRuleFormUpdateStateBulkPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleForm/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.searchSubRuleState.map(SearchSubRuleStateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SearchSubRuleStateResponseFromJSON));
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormUpdateStateBulkPost(requestParameters: ApiSearchManagerV2SearchRuleFormUpdateStateBulkPostRequest): Promise<Array<SearchSubRuleStateResponse>> {
        const response = await this.apiSearchManagerV2SearchRuleFormUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormValidatePostRaw(requestParameters: ApiSearchManagerV2SearchRuleFormValidatePostRequest): Promise<runtime.ApiResponse<SearchRuleValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManagerV2/SearchRuleForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRuleFormDataToJSON(requestParameters.searchRuleFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchRuleValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerV2SearchRuleFormValidatePost(requestParameters: ApiSearchManagerV2SearchRuleFormValidatePostRequest): Promise<SearchRuleValidationData> {
        const response = await this.apiSearchManagerV2SearchRuleFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
